const Full = () => import('@/container/Full.vue')

// dashboard components
const ResellerAdminConfigurationRoutes = () => import(/* webpackPrefetch: false */ '@/views/resellerManagement/ResellerAdminConfiguration.vue')
const ResellerStatementRoutes = () => import(/* webpackPrefetch: false */ '@/views/resellerManagement/ResellerStatement.vue')
const ResellerDashboardRoutes = () => import(/* webpackPrefetch: false */ '@/views/resellerManagement/ResellerDashboard.vue')
const ResellerManagementRoutes = () => import(/* webpackPrefetch: false */ '@/views/resellerManagement/ResellerManagement.vue')
const ResellerTransactionRoutes = () => import(/* webpackPrefetch: false */ '@/views/resellerManagement/ResellerTransaction.vue')
const ResellerRechargeRoutes = () => import(/* webpackPrefetch: false */ '@/views/resellerManagement/ResellerRecharge.vue')
const ResellerCancellationRoutes = () => import(/* webpackPrefetch: false */ '@/views/resellerManagement/ResellerCancellation.vue')

export default {
  path: '/reseller_management',
  component: Full,
  redirect: '/reseller_management',
  beforeEnter(to, from, next) {
    if (localStorage.getItem('token')) {
      next()
    } else {
      next('/signin')
    }
  },
  children: [
    {
      path: 'reseller_admin_configuration', 
      component: ResellerAdminConfigurationRoutes,
      meta: {
        title: "Reseller Management"
      }
    },
    {
      path: 'reseller_statement/:adminId?', 
      component: ResellerStatementRoutes,
      meta: {
        title: "Reseller Statement"
      }
  },
  {
      path: 'reseller_dashboard', 
      component: ResellerDashboardRoutes,
      meta: {
        title: "Reseller Dashboard"
      }
  },
  {
      path: 'reseller_management', 
      component: ResellerManagementRoutes,
      meta: {
        title: "Reseller Management"
      }
  },
   {
      path: 'reseller_transaction', 
      component: ResellerTransactionRoutes,
      meta: {
        title: "Reseller Transaction"
      }
  },
  {
      path: 'reseller_recharge', 
      component: ResellerRechargeRoutes,
      meta: {
        title: "Reseller Recharge"
      }
  },
   {
      path: 'reseller_cancellation', 
      component: ResellerCancellationRoutes,
      meta: {
        title: "Reseller Cancellation"
      }
  },
  ]
}
